import { Helmet } from "react-helmet-async";

export default function ParentalConsent() {
  return (
    <div className="min-h-screen bg-background p-6 max-w-3xl mx-auto prose prose-invert">
      <Helmet>
        <title>Parent Authorization | HeirWise</title>
        <meta
          name="description"
          content="How parents and guardians authorize a HeirWise teen learner account and manage permissions."
        />
      </Helmet>
      <h1>Parent Authorization</h1>
      <p className="text-muted-foreground">Last updated: September 23, 2026</p>

      <p>
        HeirWise learner accounts are for teens aged 13 and older, and are created inside a
        household managed by a parent or guardian. We do not offer accounts for children under 13.
      </p>
      <p>
        By creating a learner profile and granting permission in your account, you confirm that you
        are the parent or legal guardian of that learner, that the learner is at least 13 years old,
        and that you agree to the data practices described in our{" "}
        <a href="/children-privacy-notice">Teen Privacy Notice</a> and{" "}
        <a href="/privacy-policy">Privacy Policy</a>.
      </p>
      <p>
        You can review, export, delete, or withdraw this permission at any time from{" "}
        <a href="/parent/privacy">Family Privacy Controls</a>. Withdrawing permission ends the
        learner's access and starts the implemented learner-data removal process described in our
        Privacy Policy; limited audit records and anonymized aggregate statistics may remain where
        reasonably necessary.
      </p>
      <p>Questions about this page: founder@steenventures.com.</p>
    </div>
  );
}
